import { render, staticRenderFns } from "./ScorePreview.vue?vue&type=template&id=823c0cb0&scoped=true&"
import script from "./ScorePreview.vue?vue&type=script&lang=js&"
export * from "./ScorePreview.vue?vue&type=script&lang=js&"
import style0 from "./ScorePreview.vue?vue&type=style&index=0&id=823c0cb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823c0cb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCardTitle,VChip,VCol,VRow,VSimpleTable})
